import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useArticleCreate } from '@/module/Author/Article/model/ArticleQuery';
import { ArticleSchema, articleSchema, defaultArticleValues } from '@/module/Author/Article/model/ArticleSchema';
import { Article } from '@/module/Author/Article/model/ArticleTypes';
import { ImportItem } from '@/module/Sync/model/SyncTypes';

import { dangerouslyConvertType, useAppNotification } from '@feature/utils';

import { ArticleForm } from './ArticleForm';

interface ArticleSyncProps {
  onSuccess: (article: Article) => void;
  item: ImportItem;
  onCancel: () => void;

  sourceType: string;
}

function convert(item: ImportItem, sourceType: string): ArticleSchema {
  return dangerouslyConvertType<ArticleSchema>({
    ...item,
    bdis: [],
    wosCategories: [],
    wosIndexes: [],

    language: null,
    type: null,
    sourceType,
  });
}

export function ArticleSync({ onSuccess, item, onCancel, sourceType }: ArticleSyncProps) {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useArticleCreate();
  const notification = useAppNotification();

  const onSubmit = (values: ArticleSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newArticle => {
        notification.success();
        onSuccess(newArticle);
      },
    });
  };

  return (
    <>
      <Text>{item.journalName}</Text>
      <ArticleForm
        title={t('articles.form.title.create')}
        schema={articleSchema}
        defaultValues={defaultArticleValues}
        values={convert(item, sourceType)}
        isSubmitting={isPending}
        isError={isError}
        isSuccess={isSuccess}
        onSubmit={onSubmit}
        onCancel={onCancel}
        showWosFields={false}
        showScopusFields={false}
      />
    </>
  );
}
